"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var readable_node_1 = require("./readable-node");
var lodash_1 = require("lodash");
var ControlModel = /** @class */ (function (_super) {
    __extends(ControlModel, _super);
    function ControlModel(id, fields, selector, bindings, actions, _properties, metaControl, isConfigurable) {
        if (isConfigurable === void 0) { isConfigurable = false; }
        var _this = _super.call(this) || this;
        _this.id = id;
        _this.fields = fields;
        _this.selector = selector;
        _this.bindings = bindings;
        _this.actions = actions;
        _this._properties = _properties;
        _this.metaControl = metaControl;
        _this.isConfigurable = isConfigurable;
        _this.actions = lodash_1.isEmpty(actions) ? metaControl.defaultActions : actions;
        _this._hasDeletedField = lodash_1.some(lodash_1.values(_this.fields), lodash_1.isNil);
        return _this;
    }
    ControlModel.convertFields = function (fields) {
        var result = {};
        lodash_1.forIn(fields, function (value, key) {
            return lodash_1.set(result, key, value.metaFieldId.systemName);
        });
        return result;
    };
    Object.defineProperty(ControlModel.prototype, "properties", {
        get: function () {
            return this._properties;
        },
        set: function (value) {
            this._properties = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ControlModel.prototype, "hasDeletedField", {
        get: function () {
            return this._hasDeletedField;
        },
        enumerable: true,
        configurable: true
    });
    ControlModel.prototype.toJSON = function () {
        return {
            id: this.id,
            fields: ControlModel.convertFields(this.fields),
            selector: this.selector,
            bindings: this.bindings,
            actions: this.actions,
            isConfigurable: this.isConfigurable,
        };
    };
    return ControlModel;
}(readable_node_1.ReadableNode));
exports.ControlModel = ControlModel;
//# sourceMappingURL=control-model.js.map